import { commonTranslationKeys, FieldControllerProps } from '@dreryk/react-common';
import { ClassNameProp, TextInput } from '@dreryk/react-components';

type FlatInputProps = FieldControllerProps<'flat', string | null> & ClassNameProp;

export const FlatInput = (props: FlatInputProps): JSX.Element => {
   const controller = props.register(props.name, {
      required: props.required,
      maxLength: 10,
   });

   return (
      <TextInput
         testId={props.name}
         label={commonTranslationKeys.addressData.apartmentNumberAbbreviation}
         controller={controller}
         defaultValue={props.defaultValue}
         className={props.className}
      />
   );
};
